import NavBar from "@/components/woost/NavBar";
import Footer from "@/components/woost/Footer";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const Cookies = () => {
  return (
    <div className="min-h-screen bg-white">
      <NavBar />

      <motion.div
        className="container mx-auto px-4 py-20"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Link
          to="/"
          className="inline-flex items-center text-woost-blue mb-8 hover:underline"
        >
          <ArrowLeft size={16} className="mr-2" />
          Back to Home
        </Link>

        <h1 className="text-4xl font-bold mb-8">Cookie Policy</h1>

        <div className="prose prose-lg max-w-none">
          <p>Last Updated: April 18, 2025</p>

          <h2>1. Introduction</h2>
          <p>
            This Cookie Policy explains how Woost Internet Private Limited
            ("we", "us", or "our") uses cookies and similar technologies on our
            website and mobile application (collectively, the "Platform"). This
            policy should be read alongside our Privacy Policy, which explains
            how we use personal information.
          </p>

          <h2>2. What Are Cookies?</h2>
          <p>
            Cookies are small text files that are stored on your device when you
            visit a website. They are widely used to make websites work more
            efficiently and provide information to the website owners. Cookies
            can be "persistent" or "session" cookies. Persistent cookies remain
            on your device when you go offline, while session cookies are
            deleted as soon as you close your web browser.
          </p>

          <h2>3. How We Use Cookies</h2>
          <p>We use cookies for the following purposes:</p>

          <h3>3.1 Essential Cookies</h3>
          <p>
            These cookies are necessary for the Platform to function properly.
            They enable core functionality such as security, network management,
            and account access. You cannot opt out of these cookies.
          </p>

          <h3>3.2 Functional Cookies</h3>
          <p>
            These cookies enable us to provide enhanced functionality and
            personalization. They may be set by us or by third-party providers
            whose services we have added to our pages. If you disable these
            cookies, some or all of these services may not function properly.
          </p>

          <h3>3.3 Performance Cookies</h3>
          <p>
            These cookies allow us to count visits and traffic sources so we can
            measure and improve the performance of our Platform. They help us
            know which pages are the most and least popular and see how visitors
            move around the site. All information these cookies collect is
            aggregated and anonymous.
          </p>

          <h3>3.4 Targeting Cookies</h3>
          <p>
            These cookies may be set through our Platform by our advertising
            partners. They may be used by those companies to build a profile of
            your interests and show you relevant advertisements on other sites.
            They do not directly store personal information but are based on
            uniquely identifying your browser and device.
          </p>

          <h2>4. Third-Party Cookies</h2>
          <p>
            In addition to our own cookies, we may also use various third-party
            cookies to report usage statistics, deliver advertisements, and so
            on. These cookies may include:
          </p>
          <ul>
            <li>Google Analytics</li>
            <li>Facebook Pixel</li>
            <li>HubSpot</li>
            <li>Stripe</li>
            <li>Firebase</li>
          </ul>

          <h2>5. Managing Cookies</h2>
          <p>
            Most web browsers allow you to control cookies through their
            settings preferences. However, if you limit the ability of websites
            to set cookies, you may worsen your overall user experience, as it
            will no longer be personalized to you. It may also stop you from
            saving customized settings like login information.
          </p>

          <p>
            To manage cookies on different browsers, please click on the
            relevant link below:
          </p>
          <ul>
            <li>
              <a
                href="https://support.google.com/chrome/answer/95647"
                target="_blank"
                rel="noopener noreferrer"
              >
                Google Chrome
              </a>
            </li>
            <li>
              <a
                href="https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox"
                target="_blank"
                rel="noopener noreferrer"
              >
                Mozilla Firefox
              </a>
            </li>
            <li>
              <a
                href="https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac"
                target="_blank"
                rel="noopener noreferrer"
              >
                Safari
              </a>
            </li>
            <li>
              <a
                href="https://support.microsoft.com/en-us/windows/microsoft-edge-browsing-data-and-privacy-bb8174ba-9d73-dcf2-9b4a-c582b4e640dd"
                target="_blank"
                rel="noopener noreferrer"
              >
                Microsoft Edge
              </a>
            </li>
          </ul>

          <h2>6. Changes to This Cookie Policy</h2>
          <p>
            We may update our Cookie Policy from time to time. We will notify
            you of any changes by posting the new Cookie Policy on this page and
            updating the "Last Updated" date. You are advised to review this
            Cookie Policy periodically for any changes.
          </p>

          <h2>7. Contact Us</h2>
          <p>
            If you have any questions about our Cookie Policy, please contact us
            at:
          </p>
          <p>
            Woost Internet Private Limited
            <br />
            H-102, Third floor, Sector 63 Rd, H Block, Sector 63, Noida, Uttar
            Pradesh 201301
            <br />
            Email: partners@woost.io
          </p>
        </div>
      </motion.div>

      <Footer />
    </div>
  );
};

export default Cookies;
